module.exports = __webpack_public_path__ + "static/media/undiknasmobile2.8cfc9d1b.jpg";